import { requireAuth } from '@/functions';
import CompaniesHome from '@/views/companies/companies.view.vue';
import ContractsHome from '@/views/contracts/contracts.view.vue';
import EmployeesHome from '@/views/employees/employees.view.vue';
import { RouteConfig } from 'vue-router';

export const companiesRouter: Array<RouteConfig> = [
  {
    path: '/empresas',
    name: 'companies',
    component: CompaniesHome,
    beforeEnter: requireAuth,
  },
  {
    path: '/empresas/:id/colaboradores',
    name: 'companies.employees',
    component: EmployeesHome,
    beforeEnter: requireAuth,
  },
  {
    path: '/empresas/:id/contratos',
    name: 'companies.contracts',
    component: ContractsHome,
    beforeEnter: requireAuth,
  },
];
